import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import ChevronUpIcon from 'mdi-react/ChevronUpIcon';
import StarBoxIcon from 'mdi-react/StarBoxIcon';
import ViewDashboardOutlineIcon from 'mdi-react/ViewDashboardOutlineIcon';
import GiftIcon from 'mdi-react/GiftOutlineIcon';
import AccountGroupIcon from 'mdi-react/AccountGroupIcon';
import AccountGroupOutlineIcon from 'mdi-react/AccountGroupOutlineIcon';
import ComputerIcon from 'mdi-react/ComputerIcon';
import MobileDevicesIcon from 'mdi-react/MobilePhoneIcon';
import BullhornOutlineIcon from 'mdi-react/BullhornOutlineIcon';
import StadiumIcon from 'mdi-react/StadiumIcon';
import DomainIcon from 'mdi-react/DomainIcon';
import CardBulletedIcon from 'mdi-react/CardBulletedIcon';
import GavelIcon from 'mdi-react/GavelIcon';
import AccountIcon from 'mdi-react/AccountIcon';
import AccountStarIcon from 'mdi-react/AccountStarIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import CardIcon from 'mdi-react/CreditCardIcon';
import CogIcon from 'mdi-react/CogIcon';
import LogoutIcon from 'mdi-react/LogoutIcon';
import TicketIcon from 'mdi-react/TicketConfirmationIcon';
import TicketOutlineIcon from 'mdi-react/TicketOutlineIcon';
import TicketPercentIcon from 'mdi-react/TicketPercentIcon';
import NewspaperIcon from 'mdi-react/NewspaperIcon';
import CalendarIcon from 'mdi-react/CalendarIcon';
import CalendarBlankOutlineIcon from 'mdi-react/CalendarBlankOutlineIcon';
import CalendarRangeIcon from 'mdi-react/CalendarRangeIcon';
import BellIcon from 'mdi-react/BellIcon';
import CommentOutlineIcon from 'mdi-react/CommentOutlineIcon';
import ForumOutlineIcon from 'mdi-react/ForumOutlineIcon';
import AccountCheckIcon from 'mdi-react/AccountMultipleCheckIcon';
import InformationIcon from 'mdi-react/InformationIcon';
import QrcodeIcon from 'mdi-react/QrcodeIcon';
import MessageImageIcon from 'mdi-react/MessageImageIcon';
import FileSignIcon from 'mdi-react/DrawIcon';
import CashRegisterIcon from 'mdi-react/CashRegisterIcon';
import PackageVariantClosedIcon from 'mdi-react/PackageVariantClosedIcon';
import FileImportIcon from 'mdi-react/FileImportIcon';
import ChartLineIcon from 'mdi-react/ChartLineIcon';
import ChartAreasplineIcon from 'mdi-react/ChartAreasplineIcon';
import CartOutlineIcon from 'mdi-react/CartOutlineIcon';
import StoreIcon from 'mdi-react/StoreIcon';
import CloverIcon from 'mdi-react/CloverIcon';
import TagMultipleIcon from 'mdi-react/TagMultipleIcon';
import ShapeOutlineIcon from 'mdi-react/ShapeOutlineIcon';
import ImageMultipleOutlineIcon from 'mdi-react/ImageMultipleOutlineIcon';
import ShieldAccountOutlineIcon from 'mdi-react/ShieldAccountOutlineIcon';
import { partial } from '../../../util/translation/translation';
import ClubheartIcon from '../../../shared/components/custom/ClubheartIcon';

const s = partial('shared');

// Every sidebar link uses an icon from this map (via the newIcon prop), so
// they share one outline style, size and active color.
const ICONS = {
  dashboard: ViewDashboardOutlineIcon,
  match: StadiumIcon,
  matches: CalendarBlankOutlineIcon,
  event: CalendarIcon,
  offers: GiftIcon,
  quiz: CommentOutlineIcon,
  chats: ForumOutlineIcon,
  news: NewspaperIcon,
  players: AccountGroupIcon,
  layout: MobileDevicesIcon,
  weblayout: ComputerIcon,
  spotlight: BullhornOutlineIcon,
  communication: BellIcon,
  companies: DomainIcon,
  partner_activities: FileSignIcon,
  activities: CardBulletedIcon,
  sponsor: MessageImageIcon,
  auctions: GavelIcon,
  goalSponsor: ClubheartIcon,
  users: AccountIcon,
  tiers: AccountStarIcon,
  user_analytics: AccountSearchIcon,
  transactions: CardIcon,
  quarterlyReview: ChartAreasplineIcon,
  reports: ChartLineIcon,
  ticket: TicketIcon,
  tickets: TicketIcon,
  externalTickets: TicketOutlineIcon,
  discounts: TicketPercentIcon,
  cashier: CashRegisterIcon,
  packages: PackageVariantClosedIcon,
  cart: CartOutlineIcon,
  store: StoreIcon,
  lottery: CloverIcon,
  import: FileImportIcon,
  settings: CogIcon,
  seasons: CalendarRangeIcon,
  team: AccountGroupOutlineIcon,
  priceGroups: TagMultipleIcon,
  matchTypes: ShapeOutlineIcon,
  controlImages: ImageMultipleOutlineIcon,
  stadiums: StadiumIcon,
  userterms: AccountCheckIcon,
  clubprofile: InformationIcon,
  qrcode: QrcodeIcon,
  clubAdmin: ShieldAccountOutlineIcon,
  logout: LogoutIcon,
};

const SelectIcon = ({ test, active }) => {
  const Icon = ICONS[test];
  return Icon ? (
    <Icon color={active ? '#0469dc' : '#646777'} size={14} />
  ) : null;
};
const SidebarLink = ({
  title,
  icon,
  newIcon,
  newBadge,
  route,
  onClick,
  multiple,
  premium,
  beta,
  disabled,
  collapse,
  style,
  active,
  open,
}) => {
  return (
    <NavLink
      style={{ ...style }}
      to={disabled ? '/contact-sales' : route}
      onClick={onClick}
      activeClassName="sidebar__link-active"
      exact
    >
      <li
        className={`sidebar__link ${active ? 'active' : ''} ${false && open ? 'open' : ''}`}
        style={{ opacity: disabled ? 0.3 : 1 }}
      >
        {icon === 'dot' && (
          <span style={{ ...style }} className="sidebar__link-dot">
            &#8226;
          </span>
        )}
        {!!newIcon && <SelectIcon test={newIcon} active={active} />}
        {!!icon && <span className={`sidebar__link-icon icon-${icon}`} />}
        <p className="sidebar__link-title">{title}</p>
        {newBadge && !collapse && (
          <Badge
            color="danger"
            style={{ marginLeft: 10, position: 'absolute', right: 20 }}
          >
            <span>{s('new')}</span>
          </Badge>
        )}
        {false && open && (
          <ChevronUpIcon
            style={{
              marginLeft: 10,
              position: 'absolute',
              right: 20,
              top: 6,
              color: '#0469DC',
            }}
          />
        )}
        {false && !open && open !== undefined && (
          <ChevronDownIcon
            style={{
              marginLeft: 10,
              position: 'absolute',
              right: 20,
              top: 6,
              color: '#C6CAD2',
            }}
          />
        )}
        {premium && !collapse && (
          <StarBoxIcon
            style={{
              marginLeft: 10,
              position: 'absolute',
              right: 20,
              top: 6,
              color: '#703FF3',
              width: 18,
            }}
          />
        )}
        {beta && !collapse && (
          <Badge
            color="secondary"
            style={{ marginLeft: 10, position: 'absolute', right: 20 }}
          >
            <span>Beta</span>
          </Badge>
        )}
        {multiple && (
          <span className="sidebar__category-icon icon-chevron-right" />
        )}
      </li>
    </NavLink>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  route: PropTypes.string,
  onClick: PropTypes.func,
  multiple: PropTypes.bool,
};

SidebarLink.defaultProps = {
  multiple: false,
  icon: '',
  route: '/',
  onClick: () => {},
};

export default SidebarLink;
